(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* =============================================
     1. Sticky Header (original logic preserved)
     ============================================= */
  class StickyHeader extends HTMLElement {
    constructor() { super(); }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* =============================================
     2. Sticky menu bar on scroll
     Shows after the top row (logo/search/icons) scrolls off — not the whole header
     ============================================= */
  (function() {
    const stickyBar = document.getElementById('HeaderStickyMenubar');
    const topRow = document.querySelector('.header'); // logo + search + icons row only
    if (!stickyBar || !topRow) return;

    function updateStickyBar() {
      const topRowBottom = topRow.getBoundingClientRect().bottom;
      if (topRowBottom < 0) {
        stickyBar.classList.add('is-visible');
        stickyBar.setAttribute('aria-hidden', 'false');
      } else {
        stickyBar.classList.remove('is-visible');
        stickyBar.setAttribute('aria-hidden', 'true');
      }
    }

    window.addEventListener('scroll', updateStickyBar, { passive: true });
    updateStickyBar();
  })();

  /* =============================================
     4. Mega dropdown — smooth hover transitions
     ============================================= */
  (function() {
    /* --- Hover management: cross-fade between items, 150ms hide delay --- */
    document.querySelectorAll('.mega-nav').forEach(function(nav) {
      const items     = Array.from(nav.querySelectorAll('.mega-nav__item--has-dropdown'));
      const dropdowns = items.map(function(item) { return item.querySelector('.mega-dropdown'); });
      let activeIdx   = -1;
      let hideTimer   = null;

      function activate(idx) {
        clearTimeout(hideTimer);
        if (activeIdx === idx) return;
        if (activeIdx >= 0 && dropdowns[activeIdx]) {
          dropdowns[activeIdx].classList.remove('mega-dropdown--active');
        }
        if (dropdowns[idx]) {
          dropdowns[idx].classList.add('mega-dropdown--active');
        }
        activeIdx = idx;
      }

      function scheduleHide() {
        clearTimeout(hideTimer);
        hideTimer = setTimeout(function() {
          if (activeIdx >= 0 && dropdowns[activeIdx]) {
            dropdowns[activeIdx].classList.remove('mega-dropdown--active');
          }
          activeIdx = -1;
        }, 150);
      }

      /* If the search dropdown is open, hovering any nav item closes it
         (no focus stealing — just hide the panel + reset aria). */
      function closeSearchOnNavHover() {
        var sd = document.getElementById('HeaderSearchDropdown');
        if (!sd || !sd.classList.contains('is-open')) return;
        sd.classList.remove('is-open');
        ['HeaderSearchTrigger', 'HeaderMobileSearchTrigger'].forEach(function(id) {
          var t = document.getElementById(id);
          if (t) t.setAttribute('aria-expanded', 'false');
        });
      }

      items.forEach(function(item, idx) {
        item.addEventListener('mouseenter', function() {
          closeSearchOnNavHover();
          activate(idx);
        });
      });

      /* Hovering an item WITHOUT a dropdown closes any open panel. */
      const itemsNoDropdown = nav.querySelectorAll('.mega-nav__item:not(.mega-nav__item--has-dropdown)');
      itemsNoDropdown.forEach(function(item) {
        item.addEventListener('mouseenter', function() {
          closeSearchOnNavHover();
          scheduleHide();
        });
      });

      dropdowns.forEach(function(dropdown) {
        if (!dropdown) return;
        dropdown.addEventListener('mouseenter', function() { clearTimeout(hideTimer); });
        dropdown.addEventListener('mouseleave', function() { scheduleHide(); });
      });

      nav.addEventListener('mouseleave', function() { scheduleHide(); });
    });

    /* --- Sticky dropdown: switch to fixed when sticky bar is visible --- */
    var stickyBar = document.getElementById('HeaderStickyMenubar');

    function syncStickyDropdowns() {
      var activeDropdown = document.querySelector('.mega-dropdown--active');
      if (!activeDropdown) return;

      if (stickyBar && stickyBar.classList.contains('is-visible')) {
        var top = stickyBar.getBoundingClientRect().bottom;
        document.documentElement.style.setProperty('--mega-sticky-top', top + 'px');
        activeDropdown.classList.add('mega-dropdown--sticky');
      } else {
        activeDropdown.classList.remove('mega-dropdown--sticky');
      }
    }

    window.addEventListener('scroll', syncStickyDropdowns, { passive: true });
  })();

  /* =============================================
     3. Search dropdown open/close + live results
     ============================================= */
  (function() {
    const trigger       = document.getElementById('HeaderSearchTrigger');
    const mobileTrigger = document.getElementById('HeaderMobileSearchTrigger');
    const dropdown      = document.getElementById('HeaderSearchDropdown');
    const closeBtn      = document.getElementById('HeaderSearchClose');
    const searchInput   = document.getElementById('HeaderSearchDropdownInput');
    const quickLinks    = document.getElementById('HeaderSearchQuickLinks');
    const resultsPanel  = document.getElementById('HeaderSearchResults');
    const moneyFormat   = dropdown ? dropdown.getAttribute('data-money-format') : null;

    if (!dropdown) return;

    let debounceTimer = null;
    let lastQuery = '';

    function resizeImage(url, size) {
      if (!url) return '';
      return url.replace(/\.(jpe?g|png|gif|webp)(\?.*)?$/i, function(_, ext, qs) {
        return '_' + size + 'x.' + ext + (qs || '');
      });
    }

    function formatMoney(price) {
      /* /search/suggest.json returns product prices as decimal strings ("330.00").
         Only divide by 100 when the value is a plain integer (i.e. real cents). */
      var raw = String(price);
      var n = parseFloat(raw);
      if (isNaN(n)) return '';
      if (raw.indexOf('.') === -1) n = n / 100;
      var amount = n.toFixed(2);
      if (!moneyFormat) return '$' + amount;
      return moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/g, amount)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(n)))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','));
    }

    function showResults() {
      if (quickLinks) quickLinks.hidden = true;
      if (resultsPanel) resultsPanel.classList.add('is-visible');
    }

    function showQuickLinks() {
      if (quickLinks) quickLinks.hidden = false;
      if (resultsPanel) {
        resultsPanel.classList.remove('is-visible');
        resultsPanel.innerHTML = '';
      }
    }

    function renderResults(products, query) {
      if (!resultsPanel) return;

      if (!products.length) {
        resultsPanel.innerHTML = '<p class="header-search-results-empty">No results for &ldquo;' + query + '&rdquo;.</p>';
        return;
      }

      const cards = products.map(function(p) {
        const imgUrl = p.featured_image && p.featured_image.url
          ? resizeImage(p.featured_image.url, '300')
          : '';
        const imgAlt = (p.featured_image && p.featured_image.alt) ? p.featured_image.alt : p.title;
        const imgHtml = imgUrl
          ? '<img class="header-search-result-card__img" src="' + imgUrl + '" alt="' + imgAlt + '" loading="lazy">'
          : '';

        const price = p.price ? formatMoney(p.price) : '';
        const compare = p.compare_at_price_max && parseInt(p.compare_at_price_max, 10) > parseInt(p.price, 10)
          ? '<s style="font-weight:400;opacity:0.45;font-size:1.1rem;margin-left:0.4rem">' + formatMoney(p.compare_at_price_max) + '</s>'
          : '';

        const firstVariant = p.variants && p.variants[0];
        const variantId = firstVariant ? firstVariant.id : null;
        const available = p.available !== false && firstVariant && firstVariant.available !== false;
        const atcBtn = variantId
          ? '<button class="header-search-result-card__atc" data-variant-id="' + variantId + '"' + (available ? '' : ' disabled') + '>'
            + (available ? 'Add to Cart' : 'Sold Out')
            + '</button>'
          : '';

        return '<div class="header-search-result-card">'
          + '<a href="' + p.url + '" class="header-search-result-card__link">'
          + '<div class="header-search-result-card__img-wrap">' + imgHtml + '</div>'
          + '<div class="header-search-result-card__title">' + p.title + '</div>'
          + '<div class="header-search-result-card__price">' + price + compare + '</div>'
          + '</a>'
          + atcBtn
          + '</div>';
      }).join('');

      const viewAll = '<a href="/search?q=' + encodeURIComponent(query) + '&type=product" class="header-search-results-all-link">View all results for &ldquo;' + query + '&rdquo;</a>';
      resultsPanel.innerHTML = '<div class="header-search-results-grid">' + cards + '</div>' + viewAll;
    }

    function updateCartCount() {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden]');
          if (bubble) bubble.textContent = cart.item_count;
          var cartIconEmpty = document.querySelector('#cart-icon-bubble .svg-wrapper');
          if (cartIconEmpty && cart.item_count > 0) {
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          }
        })
        .catch(function() {});
    }

    function addToCart(variantId, btn) {
      btn.disabled = true;
      btn.textContent = 'Adding…';

      fetch('/cart/add.json', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (data.status) throw new Error(data.description || 'Error');
          btn.textContent = 'Added!';
          btn.classList.add('is-added');
          updateCartCount();
          setTimeout(function() {
            btn.textContent = 'Add to Cart';
            btn.classList.remove('is-added');
            btn.disabled = false;
          }, 2000);
        })
        .catch(function() {
          btn.textContent = 'Try again';
          setTimeout(function() {
            btn.textContent = 'Add to Cart';
            btn.disabled = false;
          }, 2000);
        });
    }

    if (resultsPanel) {
      resultsPanel.addEventListener('click', function(e) {
        var btn = e.target.closest('.header-search-result-card__atc');
        if (!btn || btn.disabled) return;
        e.preventDefault();
        addToCart(btn.getAttribute('data-variant-id'), btn);
      });
    }

    function fetchResults(query) {
      if (query.length < 2) { showQuickLinks(); return; }

      showResults();
      resultsPanel.innerHTML = '<p class="header-search-results-loading">Searching&hellip;</p>';

      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last')
        .then(function(r) { if (!r.ok) throw new Error('Search failed'); return r.json(); })
        .then(function(data) {
          const products = (data.resources && data.resources.results && data.resources.results.products) || [];
          renderResults(products, query);
        })
        .catch(function() {
          if (resultsPanel) resultsPanel.innerHTML = '<p class="header-search-results-empty">Could not load results. Press Enter to search.</p>';
        });
    }

    function setAriaExpanded(value) {
      [trigger, mobileTrigger].forEach(function(t) { if (t) t.setAttribute('aria-expanded', value); });
    }

    function openSearch() {
      dropdown.classList.add('is-open');
      setAriaExpanded('true');
      if (searchInput) setTimeout(function() { searchInput.focus(); }, 50);
    }

    function closeSearch() {
      dropdown.classList.remove('is-open');
      setAriaExpanded('false');
      showQuickLinks();
      if (searchInput) searchInput.value = '';
      lastQuery = '';
      const activeTrigger = (window.innerWidth <= 989 && mobileTrigger) ? mobileTrigger : trigger;
      if (activeTrigger) activeTrigger.focus();
    }

    if (searchInput) {
      searchInput.addEventListener('input', function() {
        const query = this.value.trim();
        if (query === lastQuery) return;
        lastQuery = query;
        clearTimeout(debounceTimer);
        if (query.length < 2) { showQuickLinks(); return; }
        debounceTimer = setTimeout(function() { fetchResults(query); }, 300);
      });
    }

    if (trigger) trigger.addEventListener('click', openSearch);
    if (mobileTrigger) mobileTrigger.addEventListener('click', openSearch);
    if (closeBtn) closeBtn.addEventListener('click', closeSearch);

    document.addEventListener('click', function(e) {
      if (dropdown.classList.contains('is-open')
          && !dropdown.contains(e.target)
          && (!trigger || !trigger.contains(e.target))
          && (!mobileTrigger || !mobileTrigger.contains(e.target))) {
        closeSearch();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && dropdown.classList.contains('is-open')) closeSearch();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
